import { render, staticRenderFns } from "./ComplianceContactsInfo.vue?vue&type=template&id=35a39068&scoped=true&"
import script from "./ComplianceContactsInfo.vue?vue&type=script&lang=ts&"
export * from "./ComplianceContactsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ComplianceContactsInfo.vue?vue&type=style&index=0&id=35a39068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a39068",
  null
  
)

export default component.exports